<form [formGroup]="form" (ngSubmit)="submit()" class="login-form-container">
  <div class="title-input">
    <p style="font-weight: 500; margin-bottom: 0px">CNPJ da Organização *</p>
  </div>
  <input
    matInput
    type="text"
    class="form-control"
    maxlength="18"
    formControlName="organizacao"
    mask="00.000.000/0000-00"
  />
  <div style="align-items: start; width: 100%; display: flex">
    <p
      *ngIf="form.controls['organizacao'].errors?.['CNPJinvalid']"
      style="color: red; margin-bottom: 0px"
    >
      Esse CNPJ não é valido.
    </p>
  </div>
  <div
    *ngIf="form.controls['organizacao'].dirty && form.controls['organizacao'].errors?.['required']"
    class="error-message"
  >
    <p style="margin-bottom: 0px">Informe o seu CNPJ.</p>
  </div>

  <div class="title-input">
    <p style="font-weight: 500; margin-bottom: 0px">Login *</p>
  </div>

  <input
    matInput
    type="text"
    maxlength="20"
    formControlName="login"
    class="form-control"
  />
  <div
    *ngIf="form.controls['login'].dirty && form.controls['login'].errors?.['required']"
    class="error-message"
  >
    <p style="margin-bottom: 0px">Informe o seu login.</p>
  </div>

  <div class="title-input">
    <p style="font-weight: 500; margin-bottom: 0px">Senha *</p>
  </div>

  <div class="password-input-container">
    <input
      matInput
      type="{{ hidePassword ? 'password' : 'text' }}"
      maxlength="8"
      formControlName="senha"
      class="form-control"
    />
    <button
      mat-icon-button
      (click)="togglePasswordVisibility()"
      aria-label="Toggle password visibility"
      type="button"
      class="toggle-password-button"
    >
      <mat-icon>{{ hidePassword ? "visibility_off" : "visibility" }}</mat-icon>
    </button>
  </div>
  <div
    *ngIf="form.controls['senha'].dirty && form.controls['senha'].errors?.['required']"
    class="error-message"
  >
    <p style="margin-bottom: 0px">Preencha o campo de senha.</p>
  </div>

  <div class="checkbox">
    <input id="checkbox1" formControlName="remember" type="checkbox" />
    <label for="checkbox1">Lembre-se de mim</label>
  </div>

  <button
    mat-raised-button
    color="primary"
    type="submit"
    class="login-form-container-button"
    [disabled]="this.form.invalid || this.form.pending"
  >
    ENTRAR
  </button>
</form>
